const lang = {
    // Drawer
    logOut: "Déconnexion",
    Account: "Compte",
    english: "Anglais",
    french: "Français",
    Organization: "Organisation",
    language: "Langue",
    manageAccount: "Gérer votre compte",
    Warning: "Attention",
    skip: "Passer",
    useDefault: "Utilise le style par défaut",
    reset: "Réinitialiser",
    ALL: "TOUS",
    ANY: "L'UN",
    dropYourFiles: "Glissez vos fichiers ici",
    toggleTheme: "Basculer thème clair/foncé",
    rename: "Renommer",
    Settings: "Paramètres",
    deconnection: "Déconnexion",
    areYouLeaving: "Vous partez ?",
    Avatar: "Avatar",

    new: "Nouveau",
    X: "x",

    Failed: "Erreur réseau",
    NetworkError: "Erreur réseau",
    NetworkErrors: "Erreurs réseaux",
    NotAnswered: "Non décroché",
    IntercomOnBreak: "Intercom en anbsence",
    NoAvailableIntercom: "Aucun intercom disponible",
    NotSpecified: "Non renseigné",
    Treaty: "Traité",
    SwitchToContinuousMode: "Passer en mode continu",
    ChoosingTheCapsuleToTarget: "Choix de la capsule à cibler",
    SessionAlreadyInProgress: "Session déjà en cours",
    lockedIntercom: "Votre Intercom est actuellement utilisé par un autre utilisateur. Vous pouvez déconnecter l’utilisateur en cours et reprendre le contrôle sur l’Intercom.",
    usedIntercom: "Intercom utilisé",
    TextSessionAlreadyInProgress: "Il semblerait que vous soyez déjà connecté sur une autre machine. Il vous faut fermer la session en cours avant de pouvoir en démarrer une nouvelle.",
    MessageConfirmDeconnection: "En confirmant votre déconnexion, vous allez immédiatement interrompre la communication avec la capsule.",
    AttentionCallInProgress: "Attention, un appel est en cours : ",
    IntercomLinked: "Intercom lié",
    Disconnected: "Déconnecté",
    UsedBy: "Utilisé par",
    You: "Vous",
    WrongExtension: "Mauvaise extension",
    TextWrongExtension: "Pour des raisons de sécurité, vous ne pouvez pas charger de fichiers de type .",

    //NavMenu
    tools: "Outils",
    gestion: "Gestion",
    profil: "Profil",
    dashboardFullView: "Vue d'ensemble",
    dashboard: "Dashboard",
    dashboardAgents: "Par Intercom",
    dashboardClients: "Par Origine",
    callLink: "Appel Link",
    alertDiffusion: "Diffusion d'alertes",
    portals: "Portails",
    usersAndRoles: "Utilisateurs",
    superAdmin: "Super Admin",
    organisation: "Organisation",
    Permanent: "Permanents",
    Instant: "Instantané",
    ClientsRecall: "Rappels clients",

    // Pairing Intercom
    PairingIntercom: "Associer un intercom",
    PairingImpossible: "Association impossible",
    EnterPairingCodeDisplayedOnIntercom: "Saisissez le code d'association affiché sur l'intercom :",
    ConfirmPairing: "Confirmer l'association",
    boldTextIntercomAlreadyPaired: "L'intercom sélectionné est utilisé par un autre utilisateur. ",
    TextIntercomAlreadyPaired: "Voulez-vous déconnecter cet utilisateur pour poursuivre l'association ?",
    IntercomAlreadyPaired: "Intercom déjà associé",
    boldTextIntercomDisconnected: "Impossible de joindre l'intercom : il est déconnecté. ",
    TextIntercomDisconnected: "Vérifiez qu'il est allumé et connecté au réseau ou recommencez l'association avec un autre intercom.",
    boldTextIntercomUnauthorized: "L'intercom sélectionné n'est pas rattaché à votre Centre d'appel. ",
    TextIntercomUnauthorized: "Veuillez recommencer l'association avec un autre intercom.",
    boldTextIntercomNotFound: "Le code d'association saisi est invalide. ",
    TextIntercomNotFound: "Vérifiez-le et recommencez l'association.",
    lastPairing: "dernière association",
    OtherIntercom: "Autre intercom",

    //General settings
    generalSettings: "réglages généraux",
    Attributes: "Attributs",
    Behaviors: "Comportements",
    ShowQRCode: "QR code visible",
    MuteVideos: "Videos silencieuses",
    Files: "Fichiers",
    addFile: "Ajoute un fichier",
    myPOI: "Mon Point d'interêt",
    deleteConfirm: "Supprimer ?",

    // Release note
    gotIt: "j'ai compris",
    versionReleaseNote: "SkaLink version",
    releaseNote: "Note de version",
    bugsFixe: "AMELIORATIONS",
    newInVersion: "NOUVEAU DANS CETTE VERSION",
    versionNote: "Note de version",

    // Buttons
    clear: "Tout retirer",
    addBlock: "Ajouter un bloc",
    addModule: "Ajouter un module",
    addButton: "Ajouter",
    cancelButton: "ANNULER",
    okButton: "OK",
    Validate: "Valider",
    CSVButton: "CSV",
    PDFButton: "PDF",
    PNGButton: "PNG",
    register: "Enregistrer",
    downloadSource: "Télécharger la source",
    Capture: "Capturer",
    Save: "Sauvegarder",
    SaveChanges: "Sauvegarder les changements",
    saving: "En cours sauvegarde",
    saved: "sauvé!",
    sendInvitation: "Envoyer l'invitation",
    resendInvitation: "Renvoyer l'invitation",
    confirmButton: "Confirmer",
    addAll: "Add All",
    selectButton: "Sélectionner",
    replaceButton: "Remplacer",
    refreshButton: "Rafraichir",
    browse: "Parcourir...",
    return: "Retour",
    Send: "Envoyer",
    Loading: "En cours de chargement...",
    PermanentlyEndTheCall: "Clôturer l'appel",
    Retry: "Réessayer",
    TakeControl: "Prendre le contrôle de l'intercom",
    Start: "Démarrer",
    Download: "Télécharger",
    Activate: "Activer",
    ToEnd: "Terminer",
    Mac: "Mac",
    Windows: "Windows",
    Restart: "Recommencer",
    ToContinue: "Poursuivre",

    // contenu groups actions
    cgDeleted: "Groupe de contenu supprimé",
    cgSaved: "Groupe de contenu sauvegardé",

    // User groups actions
    ugDeleted: "Rôle supprimé",
    ugSaved: "Rôle sauvegardé",
    ListUserGroups: "Liste des rôles",
    addUserGroupe: "Ajouter un rôle",
    uSaved: "Modifications sur le profil de l'utilisateur sauvegardées",

    // Compositions actions
    compDeleted: "Composition supprimée",
    compSaved: "Composition sauvegardée avec succès",
    compDuplicated: "Nouvelle composition créée",
    chooseComposition: "Choisir une composition",

    // Contents actions
    contentDeleted: "contenu supprimé",
    contentSaved: "contenu sauvegardé avec succès",
    contentDuplicated: "Nouveau contenu créé",

    // Playlists actions
    playlistDeleted: "Playlist supprimée",
    playlistSaved: "Playlist sauvegardée avec succès",
    playlistDuplicated: "Nouvelle composition créée",
    chooseplaylist: "Choisir une playlist",

    // Schedules actions
    scheduleDeleted: "Planification supprimée",
    scheduleSaved: "Planification sauvegardée avec succès",
    scheduleDuplicated: "Nouvelle planification créée",

    // Data sources actions
    dsDeleted: "Source de données supprimées",
    dsSaved: "Source de données sauvegardées avec succès",
    dsDuplicated: "Nouvelle source de données créée",

    // Deployments actions
    deploySuccess: "Déploiement réussi",
    deployInProgress: "Déploiement en cours, ceci peut prendre quelques minutes",

    // Commands to player actions
    messageSent: "Message envoyé a l'écran",

    // Display groups actions
    dgDeleted: "Arbre de décision supprimé",
    dgSaved: "Arbre de décision sauvegardé",
    addDisplayGroup: "Ajouter un Arbre de décision",
    dgList: "Afficher la liste des Arbres de décision",

    // Call center actions
    ccDeleted: "Centre d'appel supprimé",
    ccSaved: "Centre d'appel sauvegardé",

    // Display actions
    displayDeleted: "Écran supprimé",
    displaySaved: "Écran sauvegardé",
    confirmDeleteDisplay: "Supprimer cet écran?",
    confirmDeleteDisplayGroup: "Supprimer ce groupe d'écrans?",

    // Styles actions
    styleDeleted: "Style supprimé",
    styleSaved: "Style sauvegardé avec succès",

    // SuperAdmin actions
    orgEnabled: "Organisation activée",
    orgDisabled: "Organisation désactivée",
    orgCreated: "Organisation créée",

    // Tags actions
    tagsComposition: "composition",
    tagsContent: "contenu",
    tagsPlaylist: "playlist",
    tagsSchedule: "planification",
    tagsStyle: "style",
    tagsBasic: "Basique",
    tagsAdvanced: "Avancé",

    // Color
    inherited: "hérité",
    select: "Selectionné",

    // ModuleEditor
    newMenuEntry: "Nouvelle entrée de menu",
    moduleEdition: "Édition de modules",
    module: "Module",
    newModule: "Nouveau module",
    inheritStartScreen: "Hériter de l'écran de démarrage",
    inheritFrom: "Hériter de",
    moduleType: "Type de modules",
    Type: "Type",
    mode: "Mode",
    TwitterUserName: "Nom d'utilisateur",
    moduleData: "Données des modules",
    feedUrl: "URL",
    addURLToResource: "Ajouter ce lien web aux Ressources",
    mapCenterPoint: "Point central de la carte",
    longitude: "Longitude",
    moduleContent: "Contenu des modules",
    moduleCover: "Couverture du module",
    moduleHero: "Hero des modules",

    // ContentGroupList
    contentGroup: "Groupe de contenu",
    selectcontentGroup: "Selectionner un Groupe de contenu",
    chooseContentGroup: "Choisir un Groupe de contenu",
    cancel: "Annuler",
    cancelSuccess: "Déploiement annulé",
    chooseContent: "Choisir un Contenu",
    confirmDeleteContentGroup: "Supprimer ce Groupe de Contenu ?",

    // ContentListCard
    contentEdit: "Modifier",
    contentDelete: "Supprimer",
    contentAdd: "Ajouter",
    contentDuplicate: "Dupliquer",
    contentReplace: "Remplacer contenu séléctionné",

    // DataSourceList
    dataSource: "Source de données",
    noDataSource: "Pas de source de données",
    noDataSourceSelected: "aucune source de données séléctionné",
    chooseDataSource: "Choisir une source de données",

    // Content Library -> New Content
    newContentDataSources: "Sources de données",
    descriptionDataSources: "Ces modules sont disponibles dans la rubrique CONNECT",
    newContentOtherModules: "Autres modules",
    descriptionOtherModules: "Ces modules sont directement disponibles lors de l'édition de vos compositions sous les onglets \"Mise en page\" et \"Barre de navigation\"",

    // EditItemStyle
    EditStyle: "Modifier Style",
    importStyle: "Importer un Style",
    chooseStyle: "Choisir un Style",

    //Item types
    col1Title: "IMAGE & VIDEO",
    col2Title: "RESEAUX SOCIAUX",
    col3Title: "COMMUN",
    col4Title: "TEXTE",
    col5Title: "TRAJETS",
    col6Title: "CONTENU WEB",

    createNewContentDialog: "Nouveau",
    onlyInLux: "Fait pour le Luxembourg !",

    bannerTitle: "Bandeau texte",
    bannerDescription: "Affichez du texte dans un bandeau défilant",
    busTitle: "Arrêts de bus (Lux)",
    busDescription: "Affichez les horaires des bus pour un arrêt donné",
    citaTitle: "Cita",
    citaDescription: "Affichez le flux vidéo de l'une des caméras du service CITA",
    clockTitle: "Horloge",
    clockDescription: "Affichez une horloge digitale en choisissant parmi différents formats de date et d'heure",
    facebookTitle: "Facebook",
    facebookDescription: "Affichez le contenu de l'un de vos comptes Facebook",
    tableTitle: "Table",
    tableDescription: "Affichez des lignes et des colonnes de texte",
    MediaGalleryTitle: "Galerie photo",
    MediaGalleryDescription: "Galerie faite d'images et/ou de vidéos pouvant être affichées en taille réelle.",
    rssTitle: "Flux RSS",
    rssDescription: "Affichez le contenu d'un flux RSS dans un bandeau défilant",
    textTitle: "Bloc de texte",
    textDescription: "Affichez un bloc de texte correctement formaté",
    twitterTitle: "X (Twitter(",
    twitterDescription: "Affichez vos derniers posts sur votre écran d'accueil. Actualisation automatique.",
    youtubeTitle: "YouTube",
    youtubeDescription: "Affichez un flux video YouTube",
    weatherTitle: "Météo",
    weatherDescription: "Affichez les prévisions météo journalières ou hebdomadaires pour un endroit donné",
    webTitle: "Web URL",
    webDescription: "Affichez le contenu d'un site internet existant",
    imageTitle: "Image",
    imageDescription: "Le moyen le plus simple d'afficher une seule image en plein écran.",
    videoTitle: "Vidéo",
    videoDescription: "Lisez votre contenu vidéo. Les contrôles du lecteur video sont inclus.",
    htmlTitle: "Contenu HTML",
    htmlDescription: "Téléchargez et affichez votre propre contenu HTML-CSS",
    instagramTitle: "Instagram",
    instagramDescription: "Affichez le contenu de l'un de vos comptes Instagram",
    pdfTitle: "PDF",
    pdfDescription: "Publiez des documents d'une ou plusieurs pages à lire et/ou à télécharger.",
    AdsTitle: "Annonces",
    AdsDescription: "Postez vos petites annonces avec photos, organisées par catégories.",
    FlipCardTitle: "Carte à retourner",
    FlipCardDescription: "Cartes à deux faces (pile / face) qui se retourne lorsque l'utilisateur clique dessus.",
    MemoryGameTitle: "Jeu · Memory",
    MemoryGameDescription: "Le fameux jeu où il faut trouver des paires de cartes identiques!",
    surveyTitle: "Sondage / Quiz",
    surveyDescription: "Recueillir les commentaires de votre personnel et/ou évaluer leurs connaissances sur un sujet.",
    itineraryTitle: "Itinéraire",
    itineraryDescription: "Examinez le trafic et estimez le temps de trajet d'un point A à un point B.",
    jaliosAgendaTitle: "Jalios · Agenda",
    jaliosAgendaDescription: "Depuis votre intranet : événements avec leur description complète & QR Code pour l'inscription.",
    jaliosCarouselTitle: "Jalios · Carrousel",
    jaliosCarouselDescription: "Depuis votre intranet : galerie d'images et/ou de vidéos pour votre hero de l'écran d'accueil.",
    supermiroTitle: "Supermiro le Club",
    supermiroDescription: "Les dernières expériences de Supermiro le Club, affichées sur votre écran de démarrage.",
    newsFeedTitle: "Fil d'actualité",
    newsFeedDescription: "Fil d'actualité en temps réel du média de votre choix.",
    restaurantMenuTitle: "Menu restaurant",
    restaurantMenuDescription: "Affichez le menu de votre restaurant d'entreprise. Mise à jour automatique.",
    jobBoardTitle: "Tableau d'offres d'emploi",
    jobBoardDescription: "Publiez vos offres d'emploi, classées par catégorie.",

    // EditItemTop
    contentName: "Nom",
    save: "Sauvegarder",
    delete: "Supprimer",
    close: "Fermer",
    mustHaveName: "Cet objet doit avoir un nom.",
    mustHaveTitleLang: "Cet objet doit avoir un titre.",
    changeContentGroup: "Changer de Groupe de contenu",
    mustHaveContentGroup: "Cet objet doit avoir un Groupe de contenu.",
    ContentsList: "Ressources",
    preview: "Preview",
    styles: "Choisir le style à utiliser pour cette prévisualisation.",
    closing: "Fermeture",
    SaveCheck: "Souhaitez-vous sauvegarder votre travail ?",
    yes: "Oui",
    no: "Non",
    mustBeNamed: "l'élément doit être nommé",

    // EditTags
    tags: "Tags",
    existingtags: "Tags existants",
    newTag: "Nouveau tag",
    myNewTag: "Mon nouveau tag",
    tagsList: "Liste des Tags",
    label: "Tag",
    addTag: "Ajouter un tag",
    chooseTag: "Choisir un tag",
    mustSave: "Vous devez sauvegarder avant d'ajouter des Tags.",
    assignTags: "Attribuer des tags à l'ensemble des fichiers ",
    and: "et",
    or: "ou",

    // EditTags
    tagsSelection: "Ne montrer que les objets possédant ces Tags.",
    moreTag: "Tags(+)",
    startSearch: "Valider",

    // TextFontsList
    font: "Police",
    palette: "Palette",
    Fonts: "Polices",
    Palettes: "Palettes",

    // TextFontSize
    auto: "Automatique (remplit tout le champ)",

    // ErrorBoundary
    errorDevNotified: "Une erreur est survenue. Les développeurs ont été notifié.",

    // Loader
    loadingComponents: "Chargement des composants",

    // AllDisplayMonitorView
    displayGroup: "Groupe d'écrans : ",
    displayScreen: "Capture d'écrans",
    monitorDisplay: "Monitor display",

    // Status
    unknown: "Inconnu",

    // NavMenu
    ContentLibrary: "Ressources",
    Composition: "Compositions",
    Playlists: "Listes de lecture",
    Schedules: "Planifier et Déployer",
    Monitoring: "Surveiller",
    Administration: "Gestion utilisateurs",
    UsersList: "Utilisateurs",
    InvitationsList: "Invitations",
    UserGroupsList: "Rôles",
    ContentGroupsList: "Groupes de contenu",
    DisplayGroups: "Groupe d'écrans",
    Displays: "Écrans",
    PortalsAgent: "Intercoms",
    PortalsAgentTablet: "Intercoms",
    PortalAgent: "Intercom",
    PortalsClient: "Capsules",
    PortalsClientCapsule: "Capsules",
    Deployment: "Déploiements",
    Styles: "Styles",
    systemAdmin: "Super Admin",
    errorReports: "Error Reporting",
    organizations: "Organisations",
    Creation: "Créer et Concevoir",
    Security: "Permissions contenu",
    Data: "Connecter",
    DataSources: "Sources de données",
    DeploymentsCount: "Déploiements en attente",
    DisconnectedCount: "Nombre d'écrans déconnectés",
    InvitationsCount: "Invitations en attente",
    DeployMenu: "Déployer",

    // PaginationList
    nextPage: "SUIV",
    precPage: "PREC",
    goToPage: "Aller à :",
    page: "Page",
    sortByName: "Trier par nom",
    sortByDatecreated: "Trier par date",
    sortByEmail: "Trier par email",
    Filters: "Filtres",

    SortID: "ID",
    SortGroupName: "Groupe de nom",
    SortName: "Nom",
    SortCodeAgent: "Code agent",
    SortDateCreated: "Date de création",
    SortDateModified: "Date de modification",
    SortContentType: "Type",
    SortContentGroupName: "Contenu du groupe",
    SortStatus: "Statut",
    SortDisplayGroup: "Groupes d'écrans",
    SortDateDeployed: "Date déploiement",
    SortEmail: "Email",
    SortLastUpdateDate: "Date où les données ont été changé.",
    SortUniqueIdentifier: "Identifiant Unique",
    SortPreview: "Aperçu",
    SortDeployedBy: "Déployer par",
    SortCreatedBy: "Créé par",
    SortModifiedBy: "Modifié par",
    SortCurrentDeploymentName: "Dernier déploiement",
    SortCurrentDeploymentDate: "Date du dernier déploiement",
    SortSize: "Taille",
    SortLastModifiedBy: "Dernière modification par",
    SortDisplayStateUpdate: "Dernière activité",
    SortApplicationVersion: "Version",
    SortCallCenter: "Centre d'appel",
    SortUsers: "Utilisateurs",
    SortPlayerVersion: "Player",
    SortActions: "Actions",
    SortAction: "Action",
    SortDecisionsTree: "Arbre de décision",
    SortassociatedPortals: "Portails associés",
    SortPortalsClient: "Capsules associées",
    SortPortalsAgent: "Intercoms associés",
    SortZones: "Zones",
    SortZone: "Zone",
    SortOrigin: "Origine",
    SortCategory: "Catégorie",
    SortDuration: "Durée",
    SortDate: "Date",
    SortRole: "Rôle",
    SortAgent: "Agent",
    SortRating: "Évaluation",
    SortURL: "URL",
    SortDescriptive: "Descriptif",
    SortIndex: "Index",
    SortCallLink: "Lien d'appel",

    // MediaGalleryElements
    MediaGallery: "Gallerie de photo",
    addItem: "Ajouter à la planification",
    removeItem: "Supprimer de la planification",
    search: "Rechercher",
    remove: "Enlever",
    removeTag: "Retirer le tag",

    // PlaylistElements
    compositions: "Compositions",
    contents: "Contenus",
    playlist: "Playlist elements",
    addItemToPlaylist: "Ajouter à la playlist",
    removeItemFromPlaylist: "Enlever de la playlist",
    composition: "Composition",
    content: "Ressource",
    duration: "00:00:00",
    Duree: "Durée",
    duree: "durée",

    // ScheduleElements
    scheduleElements: "Eléments de la planification",
    addItemToSchedule: "Ajouter à la planification",
    removeItemFromSchedule: "Enlever de la planification",

    // ContentGroupsList
    EditContentGroup: "Modifier le groupe de Contenu",
    newContentGroup: "Nouveau groupe de contenu",
    CreateNewContentGroup: "Créer Groupe de contenu",
    deleteContentGroup: "Supprimer Groupe de contenu",
    searchByName: "Rechercher par nom",
    myGroupName: "Nouveau ContentGroup Name",
    helmetContentGroupList: "SKA - Groupes de Contenus",

    // EditContentGroup
    Delete: "Supprimer",
    DeleteAll: "Supprimer la sélection",
    Close: "Fermer",
    contentGroupName: "Nom",
    permissions: "Liste des permissions",
    UserGroups: "Rôles",
    playlists: "Playlists",
    schedules: "Planifications",
    permissionLabelNone: "Aucun",
    permissionLabelList: "Lister",
    permissionLabelRead: "Lire",
    permissionLabelUpdate: "Modifier",
    permissionLabelWrite: "Créer",
    permissionLabelDelete: "Supprimer",
    contentGroupMustHaveName: "Le Groupe de contenu doit avoir un nom",
    helmetEditContentGroup: "SKA - Edition du Groupe de contenu",
    deleteNotSaved: "Si vous n'avez pas sauvegarder vos modifications, cette action les annulera. Continuer ?",
    ok: "OK",

    // Call Log
    helmetCallLog: "SkaLink | Journal d'appels",
    callLog: "Journal d'appels",
    exportDatas: "Exporter les données",
    ID: "ID",
    CallDetails: "Détails de l'appel",
    NothingWasNotedByAgent: "Rien de particulier n'a été noté par l'agent.",
    Attachments: "Pièces jointes",
    ClientAttachments: "Pièces jointes du client",
    AgentAttachments: "Pièces jointes de l'agent",
    SendedByClient: "Fichier envoyé par le client",
    SendedByAgent: "Fichier envoyé par l'agent",
    ScreenshotByAgent: "Capture d'écran par l'agent",
    RecordingByAgent: "Vidéo enregistrée par l'agent",

    // URLCalls
    URLCallsPermanent: "Liens d'appel permanents",
    URLRecallClients: "Liens de rappels clients",
    helmetURLCalls: "SkaLink | Liens d'appel",
    helmetURLCallsPermanent: "SkaLink | Liens d'appel permanents",
    helmetURLRecallClients: "SkaLink | Liens de rappels clients",
    CallLinkCreated: "Lien d'appel créé",
    CallLinkSaved: "Lien d'appel sauvé",
    callLinkDeleted: "Lien d'appel supprimé",
    Programmed: "Programmé",
    Expired: "Expiré",
    CreateANewLink: "Créer un lien",
    CopiedToClipboard: "Copié dans le presse-papiers",
    ModifyLink: "Éditer le lien d'appel",
    CreateLink: "Créer un lien d'appel",
    detailsLink: "Détails du lien d'appel",
    days: "jours",
    Target: "Cible",
    validity: "Validité",
    ValidFrom: "Valable du",
    At: "Au",
    toHour: "à",
    QRCode: "QR Code",
    EndValidationDate: "Fin de validité du lien d'appel",
    StartValidationDate: "Début de validité du lien d'appel",
    mustHaveCallLinkName: "Le lien d'appel doit avoir un nom",
    SendCallLink: "Envoyer le lien d'appel",
    TextMessage: "SMS",
    MobileNumber: "N° mobile",
    NoCallCenterWithThisZone: "Aucun centre d'appel ne gère cette zone",
    NoCallCenterWithThisUser: "Votre utilisateur n'est pas associé à un centre d'appel",
    textDeleteURLCall: "êtes-vous sure de vouloir supprimer ce lien d'appel?",

    // Carousel / Commitment
    Advertisement: "Publicité",
    Carousel: "Carrousel",
    Commitment: "Engagement",
    Transition: "Transition",
    Fade: "Fondu",
    Slide: "Slide",
    helmetAdvertisement: "SkaLink | Publicité",
    helmetCarousel: "SkaLink | Carrousel",
    helmetCommitment: "SkaLink | Commitment",
    DisplayingAdvertisements: "Affichage des publicités",
    DownloadTemplate: "Télécharger le template",
    AdActivated: "Publicité activée",
    AdDisabled: "Publicité désactivée",
    NameSlide: "Nom du slide",
    Button: "Bouton",
    Without: "Sans",
    TextButton: "Texte du bouton",
    EditAd: "Éditer la publicité",
    CreateAd: "Créer la publicité",
    ActionButton: "Bouton d'action",
    ColorButton: "Couleur du bouton",
    Black: "Noir",
    White: "Blanc",
    Visual: "Visuel",
    Impressions: "Impressions",
    Openings: "Ouvertures",
    DeleteAdvertisement: "Supprimer la publicité ?",
    AlertRemoveAdvertisement: "la suppression de cette publicité et des ses statistiques d'engagement sera définitive et irréversible.",
    Error: "Erreur",
    ImpossibleReadImage: "Impossible de lire l'image.",
    IncorrectSize: "Dimensions incorrectes",
    ImageMustBeHaveDimensions: "L'image doit faire exactement 1440px X 2560px",
    youHave: "vous avez",


    //Call Panel
    TextIntercomUnpaired: "Aucun intercom n'est associé à votre compte",
    TextIntercomNotConnected: "Votre intercom n'est pas connecté",
    CR: "Compte-rendu",
    ShareSend: "Partages / Envois",
    Control: "Contrôle à distance",
    controltitle: "Pour prendre le contrôle à distance de l'ordinateur du client :",
    control1: "1. Demandez au client d'activer son partage d'écran.",
    control2: "2. Une fenêtre s'ouvre avec son écran partagé.",
    control3: "3. Cliquez sur \"Mac\" ou \"Windows\" (en haut à droite) en fonction du système d'exploitation utilisé par le client, puis suivez les instructions.",
    AttachmentsSendedByClient: "Envoyé par le client",
    AttachmentsSendedByAgent: "Envoyé par l'agent",
    MissingInformations: "Informations manquantes",
    RequiredAction: "Action requise :",
    textMissingInformations: "veuillez attribuer une catégorie d'appel avant de pouvoir clôturer cet appel.",

    //CallCenters
    helmetCallCenter: "SkaLink | Centres d'appel",
    CallCenters: "Centres d'appel",
    CallCenter: "Centre d'appel",
    allCallCenters: "Tous les centres d'appel",
    CreateNewCallCenter: "Créer un centre d'appel",
    editCallCenter: "Modifier le centre d'appel",
    callTransfers: "Transferts d'appel",
    callTransfersTo: "Transferts d'appel vers :",
    managedZone: "Zones gérées",
    openHour: "Horaires d'ouverture",
    exceptionClose: "Fermetures exceptionnelles",
    addDate: "Ajouter une date",
    CallTransfersOverThePeriod: "Transferts d'appels sur la période",
    Background: "Arrière-plan",
    ActivateInCall: "Activer pendant les appels",
    BadDimensionFile: "Votre fichier n'a pas la bonne dimension",
    TextSizeBackgroundImage: "Votre image doit faire 480px de largeur et 720px de hauteur.",
    closingDay: "Jour de fermeture",

    //DecisionTrees
    helmetDecisionTrees: "SkaLink | Arbres de décision",
    DecisionTrees: "Arbres de décision",
    CreateNewDecisionTree: "Créer un arbre de décision",
    CreateTree: "Créer un arbre",
    editDecisionTree: "Éditer l'arbre de décision",
    Level: "Niveau",
    addLevel1: "Ajout d'une entrée de Niveau 1",
    addLevel2: "Ajout d'une entrée de Niveau 2",
    addLevelQuestion: "Ajout d'une question",
    EditEntry: "Éditer l'entrée",
    EditQuestion: "Éditer la question",
    startLevel1: "Commencez par ajouter une entrée de premier niveau",
    startLevel2: "Ajoutez ici vos entrées de second niveau",
    Deepness: "Profondeur",
    Parameters: "Paramètres",
    myName: "Mon nom",
    Information: "Information",
    Text: "Texte",
    TextDisplayed: "Texte affiché",
    File: "Fichier",
    webLink: "Lien web",
    callButton: "Bouton d'appel",
    DefaultCC: "CA défaut",
    CompactView: "Vue compacte",
    CallButtons: "Boutons d'appel",
    TooltipDimensionsImageDecisionTree: "Dimensions recommandées : 1960 x 350 pixels, logo placé au centre (largeur max. 380 pixels).",
    TooltipDisplayDecisionTree: "Propose en permanence l'arbre de décision à l'utilisateur, même si un Centre d'appel est disponible.",
    AlwaysShow: "Toujours afficher",

    // CallCategories
    helmetCallCategories: "SkaLink | Catégories d'appel",
    CallCategories: "Catégories d'appel",
    CreateNewCallCategory: "Créer une catégorie",
    addCallCategory: "Ajout d'une catégorie d'appel",
    editCallCategory: "Editer une catégorie d'appel",
    CallCategoriesCreate: "Catégorie d'appel créée",
    CallCategoriesDeleted: "Catégorie d'appel supprimée",
    CallCategoriesEdited: "Catégorie d'appel éditée",

    //EditZones
    Zones: "Zones",
    Zone: "Zone",
    helmetEditZones: "SkaLink | Zones",
    CreateNewZone: "Ajouter une zone",
    editZone: "Éditer la zone",
    descriptif: "Descriptif",
    confirmDeleteZone: "Supprimer cette zone ?",
    zoneDeleted: "Zone supprimée",
    zoneSaved: "Zone enregistrée",
    infoZone: "Informations sur la zone",

    // EditUserGroup
    userGroupName: "Nom du rôle",
    createNewUserGroup: "Créer un nouvel d'utilisateur",
    accessRights: "Droits d'accès",
    associatedUsers: "Groupe des membres",
    users: "Membres de l'Organisation",
    usersGestion: "Gestion des utilisateurs",
    CreateContentGroup: "Créer Groupe de membres",
    AccessPlaylists: "Accès aux Playlists",
    DeployPlaylists: "Déploiement des Playlists",
    AccessContentLibrary: "Accès à la Librairie de Contenus",
    DeployContent: "Déploiement de Contenu",
    AccessSchedule: "Accès à la Planification",
    DeploySchedule: "Déploiement de Planification",
    AccessDisplays: "Accès au Écrans",
    ControlDisplays: "Contrôler des Écrans",
    ManageDisplays: "Gestion des Écrans",
    ManageOrganization: "Gestion de l'Organisation",
    CanManageAllContent: "Gestion du contenu",
    CanManageAllPortalClient: "Contrôler les Écrans",
    helmetEditUserGroup: "SkaLink | Rôles",
    disabled: "Désactivé",
    scheduleMustHavePLaylist: "Cette planification doit avoir une playlist par défaut.",
    confirmDeleteUserGroup: "Supprimer ce rôle ?",

    // UserGroupsList
    UserGroupsEdit: "Modification des rôles",
    editUserGroup: "Modifier rôles",
    newUserGroup: "Créer un rôle",
    rightsGroup: "Droits de ce groupe",
    groupMembers: "Membres du groupe",
    CreateNewUserGroup: "Créer un rôle",
    deleteUserGroup: "Supprimer un rôle",
    newUserGroupName: "Nouveau nom pour un rôle",
    helmetEditUserGroups: "SKALink | Rôle",
    CallLinkControlScreen: "Remote control",
    Storage: "Stockage",
    Messaging: "Répondeur",
    CBPayment: "Paiement CB",
    DecisionTreeCallCenterAllotment: "Arbre de décision ‣ Attribution d'un Centre d'appel",
    IntercomCallCenterAllotment: "Intercoms ‣ Attribution d'un Centre d'appel",
    UserCallCenterAllotment: "Utilisateurs ‣ Attribution d'un Centre d'appel",
    UserIntercomAllotment: "Utilisateurs ‣ Attribution d'Intercom",
    WithRestrictionOnOrigin: "Avec restriction sur la zone",
    WithCallCenterRestriction: "Avec restriction de Centre d'appel",
    WithZoneRestriction: "Avec restriction de Zone",
    Authorize: "Autoriser",
    Consult: "Consulter",
    Create: "Créer",
    Modify: "Modifier",

    //AccessRights
    canManageZone: "canManageZone",
    canManageAllZones: "Zones · toutes",
    canManageAllUsers: "Utilisateurs et Rôles· tous",
    canManageZoneUsers: "Utilisateurs · uniquement de sa zone",
    canManageAllContent: "Ressources",
    canManageAllPortalClients: "Capsules · tous",
    canManageZonePortalClients: "Capsules · uniquement de sa zone",
    canManageAllPortalAgents: "Intercoms · tous",
    canManageAllCallCenters: "Centre d'appel · tous",
    canManageAllDecisionTrees: "Arbres de décision · tous",

    // EditUser
    blockUser: "Bloquer un compte utilisateur",
    activateUser: "Activer un compte utilisateur",
    ListUsers: "Liste utilisateurs",
    AddUser: "Ajouter l'utilisateur",
    userGroups: "Rôles",
    role: "Rôle",
    availableGroups: "Organisation groups",
    email: "E-mail",
    helmetEditUser: "SKA - Modifier un utilisateur",

    // InvitationsList & UsersList
    titleInvitations: "Invitations",
    state: "Statut",
    editUser: "Modifier utilisateur",
    inviteUser: "Inviter un utilisateur",
    message: "Message",
    assignUserGroup: "Attribuer à un rôle",
    firstnameLastname: "Prénom et nom",
    logoutUser: "Déconnecter l'utilisateur ?",
    messageLogoutUser: "si l'utilisateur est en train de passer un appel au moment de la déconnexion, la communication sera immédiatement interrompue.",
    confirmLogout: "Confirmer la déconnexion",
    sendDate: "Date d'envoi",
    userMail: "E-mail de l'utilisateur",
    invitationDetail: "Détail de l'invitation",

    // InviteUser
    ResentMail: "Envoyer une invitation par email",
    invitMessage: "Message personnalisé",
    createNewUser: "Envoyer une nouvelle invitation",
    emailNeeded: "Un email valide est requis pour l'envoi d'une invitation",
    helmetInviteUser: "SKA - Inviter utilisateur",
    invitSuccessfullSave: "L'invitation à bien été envoyée",
    confirmDeleteInvitation: "Supprimer cette Invitation ?",
    invitationDeleted: "Invitation supprimé",

    // UserList
    UsersEdits: "Modification d'utilisateurs",
    Accounts: "Comptes",
    AddAccount: "Ajouter un compte",
    searchByEmail: "Recherche par email",
    CreateNewInvitation: "Ajouter un utilisateur",
    deleteInvitation: "Supprimer invitation",
    orgaUsers: "Utilisateurs de l'Organisation",
    invitations: "Invitations de l'Organisation ",
    helmetUserList: "SkaLink | Utilisateurs",
    helmetInvitationList: "SkaLink | Invitations",
    displayName: "Nom d'utilisateur",
    confirmDeleteUserOrg: "Supprimer cet utilisateur de l'organisation ?",
    orgUserRemoved: "Utilisateur supprimé.",
    removeUserFromOrg: "Supprimer l'utilisateur",
    agent: "Agent",

    // Composition -> Settings
    jaliosHero: "Jalios Hero",
    heroMode: "Mode caroussel",
    noteJaliosHero: "si la Galerie Média sélectionnée contient plusieurs photos et/ou vidéos, votre section Hero s'affichera automatiquement sous forme de Carrousel.",
    defaultImage: "Image par defaut",

    // Composition -> designer
    layoutTitle: "Mise en page",
    moduleTitle: "Modules disponibles",

    // CompositionsComponents
    kiosk: "Kiosque",

    // CompositionsList
    CompositionsList: "Modification des compositions",
    CreateNewComposition: "Créer une Composition",
    deleteComposition: "Supprimer",
    searchByTag: "Recherche par tag",
    helmetEditComp: "SKA - Modification de composition",
    helmetCompositionList: "SKA - Compositions",

    name: "Nom",
    dimensions: "Dimensions",
    compositionList: "Liste de Compositions",

    confirmDeleteItemVM: "Supprimer ce message?",
    confirmDeleteItemDescVM: "cette action est irréversible. Vous pouvez télécharger la vidéo contenue dans le message avant de le supprimer.",

    confirmDeleteItemComp: "Supprimer cette composition ?",
    confirmDeleteItemDesc: "Cette action est définitive et ne peut pas être annulée",
    textDeleteItem: "la suppression de cette entrée aura un impact sur l’arbre de décision et le dispatching de vos appels.",
    textDeleteDecisionTree: "la suppression de cet arbre de décision sera définitive et ne pourra pas être annulée.",
    confirmDelete: "Confirmer la suppression",
    duplicate: "dupliquer",

    addContent: "Ajouter un contenu",
    removeContent: "Enlever un contenu",
    addComposition: "Ajouter une composition",
    addPlaylist: "Ajouter une playlist",

    // Content Library -> Ads -> Agenda
    fixedPrice: "Prix fixe",
    priceOnDemand: "Prix sur demande",
    makeAnOffer: "Faire une offre",
    helmetAds: "SKALINK - Annonces",
    YourAdsCategories: "Vos catégories d'annonce",
    addACategory: "Ajouter une categorie",
    addAd: "Ajouter annonce",
    aboutItem: "À propos de l'article",
    category: "Catégorie",
    callCategory: "Catégorie d'appel",
    coverPic: "Photo de couverture",
    author: "Auteur",
    authorEmail: "Email de l'auteur",
    photos: "Photos",
    upPhotos: "Jusqu'à trois photos, affichées en plus de la photo de couverture",
    sales: "Vente",
    price: "Prix (€)",
    fullDescription: "Description complète",

    // Content Library -> Agenda
    eventCategories: "Catégories d'évènements",
    helmetAgenda: "SKALINK - Agenda",
    yourEventCategories: "Vos catégories d'évènements",
    addEvent: "Ajouter un évènement",
    aboutEvent: "À propos de l'événement",
    link: "Lien",
    from: "Depuis",
    to: "Pour",
    location: "Localité",
    details: "Details",
    shortDescription: "Courte description",
    titleDescription: "Titre",
    where: "Où",
    address1: "Adresse #1",
    address2: "Adresse #2",
    who: "Qui",
    speakerNumber: "Conférencier #",
    addSpeaker: "Ajouter un Conférencier",

    // Content Library -> FlipCard
    flipCardVideoImage: "Tous les côtés de la flip Card doivent comporter une vidéo ou une image",
    helmetFlipCard: "SKALINK - Flip Card",
    flipAnimation: "Animation",
    verticalFlip: "Retournement vertical",
    flipSides: "Côtés",
    flipSideA: "Côté A (visible)",
    flipSideB: "Côté B (à révélé)",

    // ContentsList
    ContentsListEdit: "Edition de contenus",
    CreateNewContent: "Créer un contenu",
    chooseType: "Choisir un type",
    chooseTemplate: "Choisir un template",
    contentType: "Type du contenu",
    contentList: "Liste de Contenus",

    confirmDeleteItemContent: "Supprimer ce contenu ?",
    deleted: "contenu supprimé",
    helmetEditContent: "SKA - Modification de Contenus",
    helmetContentLibrary: "SkaLink | Ressources",

    // Call Link
    sendContent: "Envoyer un contenu",

    //Storage
    helmetStorage: "SkaLink | Stockage",
    scanStorage: "Scanner",
    scanning: "Scan en cours",
    scanDone: "Scanné",
    unusedContent: "contenu non utilisé",
    storagenoItemsMessageLine1: "Besoin de libérer votre espace de stockage?",
    storagenoItemsMessageLine2: "Appuyez sur le bouton SCAN et découvrez le contenu purgeable",
    DeleteSelected: "Supprime",
    used: "Utilisé",
    purgeable: "Purgeable",
    manageStorage: "Gérer stockage",
    local: "Local",
    externalApi: "APIs externes",

    // ContentsListPagination
    firstPage: "Première Page",
    previousPage: "Page Précédente",
    lastPage: "Dernière Page",

    //StatusNames
    Waiting: "En attente",
    Cancelled: "Annulé",
    Processed: "Reussi",
    Uploaded: "Téléchargé",

    //EditComposition
    CompositionsListEdit: "Modifier une Compositions",

    edit: "Modifier",
    apply: "Appliquer",

    CommonResolutions: "Résolutions communes",
    Width: "Largeur d'écran",
    Height: "Hauteur d'écran",
    ApplyNewDimensions: "Appliquer les nouvelles dimensions",
    availableContents: "Contenus disponibles",

    fullScreen: "plein écran",
    exitFullScreen: "quitter le plein écran",

    editContent: "Éditer le contenu",
    BringForward: "Avancer",
    BringToFront: "Mettre au premier plan",
    SendBackwards: "Reculer",
    SendToBack: "Mettre au dernier plan",

    Landscape: "Paysage",
    Portrait: "Portrait",
    switchScreenSize: "Echanger largeur et hauteur",

    successfullSave: "Ce contenu a été sauvegardé avec succès",
    successfullSaveDisplay: "Cet écran a été sauvegardé avec succès",
    successfullSaveComposition: "Cette composition a été sauvegardé avec succès",

    limitVideoAsset: "Il ne peut y avoir plus d'une vidéo par composition.",

    SetFullScreen: "Définir le plein écran",
    SetFullHeight: " Définir la hauteur max",
    SetFullWidth: "Définir la longueur max",
    Dimensions: "Dimensions",
    chooseResizeContent: "Voulez vous redimensionner le contenu avec la composition ? (le contenu sera supprimé sinon)",
    noContentGroup: "Vous devez selectionner un Groupe de contenu pour la composition pour voir les contenu de ce rôle",
    Yes: "oui",
    No: "non",
    None: "Aucun",
    Uniform: "Uniforme",
    UniformToFill: "uniforme à remplir",
    Fill: "Remplir",
    Position: "Position",
    stretch: "Etendre",

    NewContent: "Nouveau contenu",
    SelectedContent: ["Vous avez selectionné \"", "\" dans cette composition. Souhaitez vous remplacer l'objet par \"", "\", ou simplement ajouter \"", "\" à la composition ?"],
    Replace: "Remplacer",
    Add: "Ajouter",

    UseClipLines: "Utiliser la ligne de découpage",
    ShowGrid: "Montrer la grille",
    SnapToGrid: "Grille instantanée",
    GridInterval: "Intervalle de grille",
    ShowRuler: "Montrer les règles",

    // Banner
    helmetBanner: "SKA - Modifier Bannière",

    deleteContent: "Supprimer contenu",
    confirmDeleteItem: "Supprimer ce contenu?",

    autoFont: "Taille de police auto :",
    fontsize: "Taille de police",
    durationText: "Durée du texte",
    backgroundColor: "Couleur de fond",
    textColor: "Couleur du texte",
    yourText: "Votre texte",

    // Bus
    helmetBus: "SKA - Modifier Bus",
    mustBeConnected: "L'écran doit être connecté à internet pour que ce type de contenu fonctionne",

    noCitySelected: "Pas d'arrêt séléctionné",
    labelBus: "Séléctionner un arrêt",

    mustHaveStopPoint: "Séléctionner un arrêt en cliquant sur une suggestion",

    stationsColor: "Couleur des stations",
    fontsizeTitle: "Taille des polices des Titres",

    selected: "Arrêt séléctionné: ",

    // Cita
    helmetCita: "SKA - Modifier Cita",
    labelCita: "Séléctionner une caméra Cita",
    mustHaveCamera: "Vous devez choisir une caméra Cita",
    selectedCamera: "Caméra séléctionné: ",
    none: "aucun",
    textColorTitle: "Couleur du titre",
    textFontSize: "Taille de police du titre",

    // Clock
    helmetClock: "SKA - Modifier Clock",

    fullLetters: "Lettres entières",
    shortLetters: "Lettres abrégés",
    oneDigit: "Un chiffre",
    twoDigit: "Deux chiffres",

    dayFormat: "Format du jour",
    monthFormat: "Format du mois",
    yearFormat: "Format de l'année",

    yearFull: "Complet",
    yearShort: "abrégé",

    day: "Jour",
    month: "Mois",
    year: "Année",

    helperMonthOneDigit: "Juin sera : 6",
    helperMonthTwoDigit: "Juin sera : 06",
    helperMonthFullLetters: "Août sera : August",
    helperMonthShortLetters: "Août sera : Aug",

    helperDayOneDigit: "Le 6 sera : 6",
    helperDayTwoDigit: "Le 6 sera : 06",

    helperYearFull: "2018 sera: 2018",
    helperYearShort: "2018 sera: 18",

    separator: "Séparateur",
    blankSpace: "Espace",
    timezone: "Zone de temps",
    hourFormat: "Format de l'heure",

    helperHourFull: "16:30",
    helperHourShort: "4:30 PM",

    // Facebook
    helmetFacebook: "SKA - Modifier Facebook",
    facebookLabel: "L'url de la page Facebook (ex : https://facebook.com/Artnolens/)",
    mustHaveValidKey: "L'url n'est pas valide, seules les pages publiques peuvent êtres utilisées",
    hihlightColor: "Couleurs des titres et dates",
    primaryColor: "Couleur du Contenu",
    secondaryColor: "Couleur du logo",
    mediumFontSize: "Taille de police du contenu",
    smallFontSIze: "Taille de police des titres et dates",
    connectFacebook: "Connection à Facebook",
    descriptionFacebook: "Vous pouvez uniquement voir les pages Facebook d'un compte que vous possédez.",
    selectFacebookPage: "Pages disponibles",
    noFacebookPages: "Aucune page Facebook n'est disponible",

    // HTMLContent
    helmetHtmlContent: "SKA - Modifier contenu Html",
    selectZipFile: "Choisir un fichier .zip",
    changeZipFile: "Changer le fichier .zip",
    fileInput: "Selectionner ou glisser un fichier",
    noFileSelected: "Aucun fichier séléctionné",
    selectedFile: "fichier séléctionné : ",
    explainHtmlContent: "Charger votre propre contenu HTML. Le fichier zip doit contenir un fichier index.html à la racine",
    mustHaveFile: "Vous devez choisir au moins un fichier pour continuer",

    loadingGifColor: "Couleur du gif de chargement",

    // Image
    selectImage: "Choisir une image",
    changeImage: "Change une image",
    mustHaveImage: "Cet objet doit avoir une image.",
    helmetImage: "SKA - Image",
    helmetPDF: "SKA - PDF",
    uploadInProgress: "Chargement en cours, veuillez patienter",
    selectPreviewImage: "Choisir image de Prévisualisation",
    autoGenerated: "Générée automatiquement si rien n'est séléctionné",

    // Instagram
    helmetInstagram: "SKA - Modifier Instagram",
    descriptionInstagram: "Vous pouvez uniquement voir les photos Instagram d'un compte que vous possédez.",
    connect: "Connection à Instagram",
    succesfullyAuthenticated: "Vous êtes authentifier en tant que : ",
    waitingToConnect: "En attente de connection à Facebook...",

    // List
    helmetList: "SKA - Modifier Table",

    FirstRowAsHeader: "Entêtes styliser la première ligne",
    AlternateRowBackground: "Arrière-plan de lignes alternées",

    newText: "Votre texte",
    newTitle: "Titre",
    addRow: "Ajouter une ligne",
    removeRow: "Supprimer cette ligne",
    removeColumn: "Supprimer cette colonne",
    addColumn: "Ajouter colonne",

    // MediaGallery
    addAsset: "Choisir des images",
    changeAsset: "Changer les images",
    addMedia: "AJOUTER UN MEDIA",

    helmetMediaGallery: "SKA - Modifier Media gallery",
    durationPerItem: "Durée par image (secondes)",
    transition: "Transition",
    fileTooBig: "Vos fichiers sont trop lourds",
    fileTooBigDesc: "Les fichiers ne doivent pas excédé ",
    defaultTransition: "Transition par défaut",
    defaultDuration: "Duration par défaut",

    // Memory Game
    memoryGameTitle: "Memory Game",
    helmetMemoryGame: "SKALINK - Game · Memory",
    commonFace: "face commune",
    cards: "Cartes",

    // JobBoard
    helmetJobBoard: "SKA - Job Board",
    jobBoard: "Tableau d'offres d'emploi",
    jobNotDefined: "Non défini",
    jobUnFixedContract: "Contrat à durée indéterminée",
    jobFixedContractFullTime: "CDD · Temps plein",
    jobFixedContractPartTime: "CDD · Temps partiel",
    jobPermanentContractFullTime: "CDI · Temps plein",
    jobPermanentContractPartTime: "CDI · Temps partiel",
    jobCategories: "Catégories d'emploi",
    yourJobCategries: "Vos catégories d'emploi",
    jobs: "Emplois",
    addJob: "Ajouter un emploi",
    aboutJob: "A propos de l'emploi",
    contract: "Contrat",
    jobDescription: "Description de l'emploi",
    application: "Postuler",
    pageURL: "Page URL",
    note: "Note",
    linkToApply: "Insérez le lien vers la page Web de l'application. Un QR code sera automatiquement généré, permettant au candidat de postuler directement depuis son téléphone portable.",
    photo: "Photo",
    newSwitch: "Nouveau",

    // PDF Menu
    pdfMenu: "Menu PDF",

    // RSS
    rss: "RSS",
    helmetRSS: "SKA - Modifier RSS",
    rssLabel: "URL de votre flux RSS",
    mustBeValidUrl: "Votre url n'est pas valide",

    // Text
    helmetText: "SKA - Modifier Text",
    left: "gauche",
    right: "droite",
    center: "centrer",
    justify: "justifier",
    fontSize: "Taille de police",
    percent: "%",
    notFound: "404",

    // X (Twitter)
    twitterUser: "Utilisateur X (Twitter)",
    helmetTwitter: "SKA - Modifier X (Twitter)",
    twitterLabel: "Nom de votre timeline X (Twitter)",
    selectHashtag: "Changer pour #",
    selectAt: "Changer pour @",
    usernameTwitterNeeded: "Un identifiant X (Twitter) valide est requis.",
    checkButtonTwitter: "A vérifier",
    checkedButtonTwitter: "Vérifié",
    displayBehavior: "Afficher",
    textVerifiedTwitter: "Obligatoire avant la sauvegarde du module",
    xFeedTwitter: "X Feed (Twitter)",
    headline: "Gros titre",
    latest10Posts: "10 derniers posts",
    latest20Posts: "20 derniers posts",
    latest50Posts: "50 derniers posts",
    latest100Posts: "100 derniers posts",
    usernameTwitterExist: "Un twitter associé à cet identifiant est déjà présent dans votre librairie de contenus.",

    // Video
    selectVideo: "Choisir une vidéo",
    changeVideo: "Changer la vidéo",
    helmetVideo: "SKA - Video",
    isMute: "Son silencieux",

    // Weather
    helmetWeather: "SKA - Modifier Météo",
    mustHaveCity: "Veuillez choisir une ville en cliquant sur une suggestion",
    showForTheDay: "Montrer les prévisions pour la journée",
    showForTheWeek: "Montrer les prévisions pour la semaine",
    primaryColorWeather: "Couleur du titre et de la température",
    secondaryColorWeather: "Couleur des informations secondaires",
    backgroundColorWeather: "Couleur de fond",
    FullScreen: "Toutes les infos et prévisions",
    NormalScreen: "Infos critiques et prévisions",
    Banner: "Bannière avec infos critiques et prévisions",
    MinifiedScreen: "Uniquement les infos critiques",

    // WebURL
    helmetWebURL: "SKA - Web URL",
    webURL: "webURL ex: http://www.inui-studio.com/",
    mustHaveUrl: "Ce contenu doit contenir une URL",

    // Youtube
    helmetYoutube: "SKA - Modifier Youtube",
    key: "Youtube url (ex : https://www.youtube.com/watch?v=WV_CJCWQYY0 )",
    mustHaveValidKeyYoutube: "Ce contenu doit contenir une url Youtube valide",

    // DataSourcesList
    helmetDataSourcesList: "SKA - Data sources",
    CreateNewDataSource: "Créer une nouvelle source de données",

    confirmDeleteDataSource: "Supprimer cette source de données ?",
    confirmDeleteDataSourceDesc: "Cette action est définitive et ne peut pas être annulée",
    chooseTypeDataSource: "Choisir un type de source de données",

    // TableDataSource
    helmetTableDataSource: "SKA - Modifier source de données",
    titleDataSource: "Table de source de données",
    dataSourceName: "Nom",

    // TextDataSource
    helmetTextDataSource: "SKA - Modifier source de données",
    titleTextDataSource: "Texte de source de données",

    // DeploymentList
    DeploymentList: "Plannificateur de déploiements",
    helmetDeploymentList: "SKA - Déploiements",
    history: "Liste des Déploiements",
    newDeploy: "Nouveau déploiement",

    scheduleDeploy: "Calendrier",
    screen: "Écrans",
    compo: "Compos°",

    DeploymentStatus: "Statut",
    DeploymentDate: "date de déploiement",
    DeploymentType: "Type",
    DeploymentGroup: "Groupe de contenu",
    ShowScheduleCalendar: "Montrer la planification avancée",
    numberOfDeployedScreens: "Nombre d'écrans déployés / nombre d'écrans dans le groupe",

    DisplayGroup: "Afficher le groupe",
    Schedule: "Planification",
    Date: "Date",
    lang: "fr-FR",
    of: " de ",

    // NewDeployment
    helmetNewDeployment: "SKA - Nouveau Déploiement",
    Deploy: "Déploiement",
    TargetedDisplayGroups: "Groupe d'écrans ciblé",
    organizationDisplayGroups: "Groupe d'écrans de l'Organisation",
    schedule: "Planification à déployer",
    mustHaveDisplayGroup: "Vous devez choisir au moins un groupe d'écrans",
    ExpectedDeploymentDate: "Date de déploiement attendu",

    // Login
    doyouwisthToLogin: "Souhaitez-vous vous connecter?",
    login: "Connexion",
    welcome: ", Bienvenue sur SKA",
    noOrganisation: "Vous devez être invité dans au moins une organisation avant d'aller plus loin.",
    organization: "Organisation courante : ",
    home: "Accueil",
    helmetLogin: "SkaLink | Bienvenue",

    // containers -> Home
    click: "Clic",

    // Dashboard
    helmetDashboard: "SkaLink | Dashboard",
    chooseZone: "Choix de la zone",
    period: "Période",
    sessionsCardTitle: "sessions",
    infosReportSessions: "36% des sessions ont généré des appels",
    calls: "appels",
    call: "appel",
    lost: "perdu",
    callHandledCardTitle: "appels traités",
    callLostCardTitle: "Appels perdus",
    durationCallCardTitle: "Durée moyenne",
    durationSumCallCardTitle: "Durée totale",
    infosReportDurationCall: "Moyenne sur 139 appels",
    satisfactionClient: "Satisfaction client",
    SatisfactionClientAverage: "Satisfaction client (moy.)",
    noRating: "Aucune note",
    ContinuousModeTransitions: "Passages en mode continu",
    ListOfEvents: "Liste des évènements",
    lostCalls: "appels perdus",
    AverageOn: " appels pour une durée totale de ",
    Average: "Moyenne",
    average: "moyenne",
    Avg: "Moy.",
    avg: "moy.",
    total: "totale",
    Total: "Totale",
    TotalCall: "Total des appels",
    IntercomName: "Nom de l'Intercom",
    overThePeriod: "sur la période",
    OverThePeriod: "Sur la période",
    ofCalls: "des appels",
    totalOverThePeriod: "Total sur la période",
    TreatedBy: "Traités par",
    By: "Par",
    To: "Vers",
    the: "le",
    Jours: "Jours",
    Timings: "Horaires",
    DistributionOf: "Répartition des",
    weekdayCalls: "appels sur la semaine",
    byTimeSlots: "par tranches horaires",
    Categories: "Catégories",
    DisponibilityClients: "Disponibilité Capsules",
    DisponibilityAgents: "Disponibilité Intercoms",
    Sujets: "Sujets",
    AbsentMode: "Mode absence",
    DisturbedSituations: "Mode continu",
    TotalTimeInAbsentModeByIntercom: "Durée totale en mode absence, par intercom",
    inAbsentMode: "en mode absence",
    AllZones: "Toutes zones",

    // CallLink
    helmetCallLink: "SkaLink | Appel Link",
    client: "Client",
    treatedbyat: "Traité par / le",
    company: "Société",
    contact: "Contact",
    notDefined: "Non défini",
    DefineCateg: "définir une catégorie...",
    selectContent: "Sélection de contenu",
    URLCalls: "Liens d'appel",
    CallApp: "Webcall",
    TargetCA: "CA Cible",
    LinkValidity: "Validité du lien",
    Sharescreen: "Partage d'écrans",
    ClientSharescreen: "Partage d'écran client",
    MyComputerScreen: "L'écran de mon ordinateur",
    Payment: "Paiement",
    AskingForConsent: "Demander le consentement",
    ConsentRequestSent: "Demande de consentement envoyée",
    ConsentGranted: "Consentement accordé",
    DescriptionConsentGranted: "Le client a donné son consentement pour la transmission et exploitation des données de sa carte bancaire dans le cadre de sa demande.",
    ConsentRefused: "Consentement refusé",
    DescriptionConsentRefused: "Le client n'a pas donné son consentement pour la transmission et exploitation des données de sa carte bancaire dans le cadre de sa demande.",
    SendingContent: "Envoi de contenu",
    FromMyComputer: "Depuis mon PC",
    Resource: "Ressource",
    Notes: "Notes",
    DescriptionNotes: "Indiquer par quel biais le client a été incité à utiliser le dispositif, autres informations utiles, …",
    FileSentByClient: "Fichier envoyé par le client",
    FileSentByIntercom: "Fichier envoyé par l'intercom",
    FileSentByPilot: "Fichier envoyé par le pilot",
    VideoRecorded: "Enregistrement vidéo",
    VideoRecordedIntercom: "Enregistrement vidéo de l'intercom",
    TextParingCodeLine1: "Saisissez le code de vérification transmis par le client.",
    TextParingCodeLine2: "Après validation, la prise de contrôle à distance pourra démarrer.",
    ErrorTextParingCodeLine1: "Code de vérification invalide. Merci de contrôler les chiffres saisis et de réessayer.",
    ErrorTextParingCodeAlreadyUsedLine1: "Ce code de vérification est déjà associé à une prise de contrôle d'écran en cours. Merci de contrôler les chiffres saisis et de réessayer.",
    StartRemoteControl: "Démarrer la prise de contrôle",
    ControlClientComputer: "Contrôler l'ordinateur du client",
    allAttachments: "Toutes les pièces jointes",
    noAttachment: "Il n'y a aucune pièce jointe pour le moment.",

    //WaitingList
    helmetWaitingList: "SkaLink | File d'attente",
    WaitingList: "File d'attente",
    personsWaiting: "personnes en attente",
    TotalNumberOfPeopleWaiting: "Nombre total de personnes en attente",
    Mobile: "Mobile",
    Computer: "Ordinateur",
    Capsule: "Capsule",
    WaitTime: "Temps d'attente",
    Device: "Appareil",
    activeFlux: "flux actifs",

    welcomeDashboard: "Bienvenue",
    todayStats: "AUJOURD'HUI",
    monthStats: "30 JOURS",
    cumulatedSessions: "Sessions cumulées",
    on: "du",
    updatedHour: "Mis à jour à ",
    sessionsOn: "Sessions du ",
    top5Kiosk: "Top 5 Kiosks les plus performants",
    top5Content: "Top 5 Modules les plus performants",
    sessions: "Sessions",
    sessionsDay: " · Par jour",
    sessionsHour: " · Par tranche horaire",
    moduleOpenings: "Modules ouverts",
    modulesDay: " · Par jour",
    modulesHour: " · Par tranche horaire",
    top10Kiosk: "Top 10 Kiosks les plus performants",
    top10Module: "Top 10 Modules les plus performants",

    // VideoPlayer
    PreviewUnavailable: "Prévisualisation non disponible.",

    // DisplayGroupsList
    DisplayGroupsList: "Modifier le groupe d'écrans",
    CreateNewDisplayGroup: "Créer un nouveau Groupe d'écrans",
    deleteDisplayGroup: "Supprimer Groupe d'écrans",
    newDisplayGroupName: "Nouveau nom du Groupe d'écrans",
    helmetDisplayGroupList: "SKA - Groupe d'écrans",
    newScreenGroup: "Nouveau groupe d'écrans",
    about: "A propos",

    // EditDisplayGroup
    EditDisplayGroup: "Modifier Groupe d'écrans",
    helmetEditDisplayGroup: "SKA - Modifier Groupe d'écrans",
    contentToDIsplay: "Contenu à afficher",
    currentDisplays: "Groupe d'Écrans",
    allDisplays: "Écrans de l'Organisation",
    alertName: "Le Groupe d'Écrans doit avoir un nom",
    changeSaved: "Sauvegardé",
    descriptionLabel: "Description",
    editDisplay: "Modifier l'écran",

    // DisplayList
    helmetPortals: "SkaLink | Portails",
    helmetPortalAgent: "SkaLink | Intercoms",
    helmetPortalClient: "SkaLink | Capsules",
    DisplaysList: "Modification des Écrans",
    CreateNewDisplay: "Ajouter une capsule",
    CreateNewPortalAgent: "Ajouter un intercom",
    editIntercom: "Editer l'intercom",
    editCapsule: "Editer la capsule",
    SizeCapsule: "Format Capsule",
    inch: "pouces",
    infoIntercom: "Informations de l'intercom",
    infoCapsule: "Informations de la capsule",
    deleteDisplay: "Supprimer un Groupe d'Écrans",
    helmetDisplayList: "SKA - Écrans",
    editScreen: "Modifier les écrans",
    screenGroup: "Groupe d'écrans",
    newIntercom: "Nouvel intercom",
    newCapsule: "Nouvel capsule",
    hisDescritif: "Son descriptif",
    lastCall: "Dernier appel",
    ShowAllLogs: "Afficher tous les logs",
    NoLogsInStorage: "Pas de logs en storage",
    CallInProgress: "Appel en cours",
    OffLine: "Hors ligne",
    BreakMode: "Mode pause",
    SleepMode: "Mode absence",
    ByDefault: "Par défaut",
    Available: "Disponible",
    IncomingCall: "Appel entrant",
    NoStatus: "Pas de statut",
    StatusCapsule: "Statut de la capsule",
    StatusIntercom: "Statut de l'intercom",
    MessageStatusAvailableCapsule: "Choisissez ce statut pour que la capsule fonctionne normalement.",
    MessageStatusAvailableIntercom: "Choisissez ce statut pour que l'intercom fonctionne normalement.",
    MessageStatusSleepModeCapsule: "La capsule affiche un message indiquant aux utilisateurs que le service est indisponible.",
    MessageStatusSleepModeIntercom: "L'intercom n'est plus en mesure de recevoir les appels.",

    // CallApp
    ActiveWebcalls: "webcalls actifs",

    // EditDisplay
    displaysList: "Ecrans",
    addDisplay: "Ajouter écran",
    EditDisplay: "Modification d'un Écrans",
    helmetEditDisplay: "SKA - Groupe d'Écrans",
    CreateDisplay: "Créer un nouvel Écran",
    SaveModif: "Sauvegarder les changements",
    alertType: "L'écran doit avoir un Type d'écrans",
    alertCode: "L'écran doit avoir un code d'identification",
    alertContent: "L'écran doit être connecté à un Groupe d'écrans",
    identificationCode: "Code d'identification",
    displayType: "Type d'écran",
    screenMonitoring: "Écran de surveillance",
    displayGroups: "Groupes d'écrans",
    hide: "cacher sur l'écran",
    show: "Afficher sur l'écran",
    sendLogs: "LOGS",
    sendInfos: "INFOS",
    status: "Statut de l'écran ",
    securityLock: "Securité bloquée",
    restart: "Rédémarrer l'écran",
    powerOff: "Éteindre l'écran",
    mute: "Couper le son",
    unmute: "Activer le son",
    volumeUp: "Monter le volume",
    volumeDown: "Baisser le volume",
    getScreenShot: "Montrer capture d'écran",
    timerScreenShot: "Une nouvelle capture d'écran sera disponible dans quelques minutes",
    getScreenStream: "Écran live",
    getScreenStreamdetailed: "Capture d'écran toutes les 5 secondes pendant 1mn",
    noScreenShot: "Cet Écran n'a pas encore pris de capture d'écran",

    securityunLock: "Securité débloquée",
    VOL: "VOL",
    MUT: "MUT",
    SEC: "SEC",

    downloadLogFile: "Télécharger le fichier de log",
    logFileReadyToDownload: "Fichier de log prêt au téléchargement",

    waitingForLogs: "En attente des logs...",
    showLiveLogs: "Afficher la console en direct",
    showLiveScreen: "Afficher les captures d'écrans en direct",
    displayLocation: "Emplacement",

    // Not Found
    pageNotFound: "Page non trouvée",

    // Playlist
    CreatePlaylist: "Créer une Playlist",
    helmetPlaylist: "SKA - Créer une Playlist",
    confirmDeletePlaylist: "Supprimer cette playlist?",
    confirmDeletePlaylistDesc: "Cette action est définitive et ne peut pas être annulée",

    // PlaylistList
    helmetPlaylists: "SKA - Playlists",
    CreateNewPlaylist: "Créer une playlist",

    // AdvancedSchedules
    helmetSchedules: "SKA - Planifications",
    defaultPlaylist: "Playlist par défaut",
    defaultPlaylistHelp: "Playlist qui sera lancée quand rien n'est séléctionné",

    previewNotAvailable: "La preview n'est pas disponible pour les Planifications avancés",

    style: "Style de la Planification",
    default: "Defaut",
    chooseStyleSchedule: "Choisir le style de la planification",
    choosePlaylist: "Choisir les playlists de la planification",
    SchedulePlaylists: "Playlists de la Planification",
    OrganizationPlaylist: "Playlists disponible",

    Playlist: "Playlist",
    End: "Fin",
    allDayEvent: "Événement d'une journée",
    Repeat: "Répéter",
    Description: "Descriptif",

    // BasicSchedule
    CreateSchedule: "Crée une Planification",
    confirmDeleteSchedule: "Supprimer cette Planification ?",
    confirmDeleteScheduleDesc: "Cette action est définitive et ne peut pas être annulée",

    // SchedulesList
    helmetSchedulesList: "SKA - Planifications",
    CreateNewSchedule: "Nouvelle planification",
    CreateNewAdvancedSchedule: "Créer une Planification avancée",
    advancedScedule: "Avancé",
    basicSchedule: "Basique",
    AdvancedScheduleDescription: "Vous déploierez rapidement une ou plusieurs listes de lecture qui joueront en boucle infinie.",
    CreateNewBasicSchedule: "Créer une Planification basique",
    BasicScheduleDescription: "Deployez une ou plusieurs playlist qui s'enchaîneront l'une à la suite de l'autre.",

    advanced: "Calendrier",
    basic: "Basique",

    // Search
    helmetSearch: "Recherche de page",
    selection: "Tags ",
    otherInfos: "Autres informations",
    Search: "Rechercher",
    SearchComingSoon: "Rechercher",

    // Style
    hello: "Hello, world!",
    helmetStyle: "SKA - Styles",
    titleStyles: "Styles",
    deleteStyle: "Supprimer le style",
    confirmDeleteStyle: "Supprimer ce style?",
    confirmDeleteStyleDesc: "Cette action est définitive et ne peut pas être annulée",
    styleDuplicated: "Nouveau style créé",

    ApplicationFontFamily: "ApplicationFontFamily",

    ApplicationBackgroundColor: "Arrière plan de la composition",
    PrimaryBackgroundColor: "Arrière plan du contenu",
    SecondaryBackgroundColor: "Arrière plan alternatif du contenu",
    HighLightColor: "Couleur du texte en surbrillance",
    PrimaryColor: "Couleur de texte normal",
    SecondaryColor: "Couleur de texte alternative",

    BigTextFontSize: "Taille de police des titres",
    MediumTextFontSize: "Taille de police des textes normaux",
    SmallTextFontSize: "Taille de police des petits textes",

    EditContentStyleDialog: [
        "Il vous sera demandé de choisir un style global qui sera appliqué à ce contenu ",
        "au moment de la planification du déploiement.",
        "Alternativement, vous pouvez décider d'appliquer un thème fixe à ce contenu particulier afin que le style de planification et de déploiement soit ignoré pour ce contenu particulier.",
        "Commencez à modifier les valeurs ci-dessous par vous même, ou ",
        "importez les depuis votre librairie de styles."
    ],

    inheritedStyle: "Inchangé, le style de déploiement sera utilisé",
    overridedStyle: "Remplacé !",
    import: "Importer",

    // StylesList
    helmetStyles: "SKA - Styles",
    CreateNewStyle: "Créer un nouveau style",

    // ErrorReport
    helmetErrorReport: "Rapport d'erreur",
    source: "Source: ",
    browser: "Navigateur: ",
    user: "Utilisateur ",
    exception: "Exception: ",
    date: "Date: ",
    url: "Url: ",
    options: "Options: ",
    localStorage: "stockage local: ",
    navigator: "Navigateur",
    statusCode: "Code d'état",
    sourceError: "Source",
    creatorError: "Createur",
    dateError: "Date",
    statusError: "Statut",

    // ErrorReportList
    helmetErrorReports: "SKA - Rapport d'erreur",

    // Organization
    titleOrg: "Créer une organisation",
    helmetOrg: "SKA - Créer une organisation",

    organizationName: "Nom de l'organisation",
    organizationAdminEmail: "Email de l'administrateur",

    mustHaveOrgName: "l'Organisation doit avoir un nom",
    mustHaveOneEmail: "l'Organisation doit avoir au moins un administrateur",
    emailMustBe: "Une ou plusieurs addresse email est invalide",
    isDisabled: "Désactivé",

    // Super Admin
    helmetSuperAdmin: "SkaLink | Super Admin",

    // OrganizationList
    CreateNewOrg: "Créer une Organisation",
    helmetOrganization: "SkaLink | Organisations",

    organizationList: "Listes des Organisation",

    enableOrg: "Activer cette organisation ?",
    Enable: "Activer",

    confirmDisableItem: "Désactiver cette organisation?",
    confirmDisableItemDesc: "Tout les utilisateurs ne pourront rien faire dans cette organisation",
    confirmDisable: "désactiver",

    // LoginCallback
    loggingIn: "Connexion en cours",

    compositionIsVisibleLabel: "Est visible",
    compositionPreviewLabel: "Prévisualisation",
    compositionDescriptionLabel: "Description",

    languageName: "Nom de la langue",
    languageCode: "Code de la langue",
    languageCheckDefault: "Coché par défaut ?",

    organizationSaved: "Organisation sauvegardée !",

    nodeName: "Nom des noeuds",
    nodeParameters: "Paramètres des noeuds",
    maxDepth: "Profondeur max",

    compositionParameters: "Paramètres",
    compositionTitle: "Titre ",
    compositionDescription: "Description ",
    compositionIsVisible: "Visible ",
    compositionKiosk: "Bibliothèques",

    parameterName: "Nom du paramètre",
    parameterDisplayName: "Nom d'affichage du paramètre",
    defaultValue: "Valeur par défaut (optionnel)",
    compositionType: "Type",

    string: "Chaine de caractères",
    int: "Entier",
    dateTime: "Date",
    time: "heure",
    times: "heures",
    urlOrganization: "Url",
    FormOrganization: "Formulaire",
    textOrganization: "Texte",
    tableOrganization: "Table",
    contestOrganization: "Concours",

    playerUI: "Player UI",
    languages: "Langages",
    OrganizationParameters: "Paramètres d'organisation",
    OrganizationFiles: "Fichiers d'organisation",
    chooseFile: "Choisir fichier",
    OrganizationModules: "Modules d'organisation ( parmis : ",
    compositionConfig: "Cnfiguration de la composition",
    compositionParameter: "Paramètre de la composition",
    compositionDefaultTree: "Arborescence par défaut de la composition",
    compositionDefaultTreeAvailable: "Arborescence par défaut de la composition (disponible après sauvegarde)",
    newOrganization: "Nouvelle Organisation",
    Users: "Utilisateurs",
    administrators: "Administrateurs",

    selectPDF: "Choisir un PDF",
    changePDF: "Changer le PDF",

    onlyOneFilePDF: "Veuillez déposer 1 seul fichier PDF ou une seule image pour la prévisualisation",
    onlyOneFile: "Vous ne pouvez pas déposer plusieurs fichiers pour ce type de contenu",
    dropFileFromYourComputer: "Vous devez choisir un fichier depuis votre ordinateur",
    unsupportedFileFormat: "Format de fichier non supporté",

    SortLangs: "Langues",

    captureFrame: "Capturer l'image",

    dateCantBeInThePast: "La date de déploiement doit être dans le futur!",

    unexpectedError: "Une erreur est survenue",
    unexpectedErrorDescription: "Rafraichissez la page ou contactez nous pour résoudre le problème",
    refreshPage: "Rafraîchir la Page",

    ImportFiles: "Importer des Fichiers",
    ImportFilesTitle: "Importer des fichiers",
    AddWebLink: "Ajouter un lien web",
    titleErrorImportFiles: "⚠️ Format de fichier non supporté",
    errorImportFiles: "SKA n'accepte pas ce type de fichier. Veuillez importer un format supporté comme .jpg / .jpeg / .png / .pdf ou .mp4.",
    browseFiles: "Parcourir vos fichiers",
    UploadManager: "Import en cours",
    uploadManagerInProgress: "En cours",
    uploadManagerQueue: "File d'attente",
    uploadManagerDone: "Terminé",
    uploadDownloaded: "Téléchargé",
    uploadWaiting: "En attente",
    processing: "Traitement en cours",
    uploadManagerWait: "Veuillez attendre, ceci peut prendre quelques minutes",
    assignTheUpload: "Assigner au groupe:",
    confirmUpload: "Lancer l'importation",
    generatingThumbnails: "Génération des miniatures",
    addMore: "ajouter plus",

    appProtocol: "Application du protocole",
    isRequired: "Obligatoire",
    isRequiredDesc: " est obligatoire.",
    TheParameter: "Le paramètre ",
    mustBeAValidUrl: " doit être une URL valide.",

    mustHaveComposition: "Vous devez selectionner une composition",
    chooseDisplayGroup: "Choisir un groupe d'écrans",

    noItems: "Rien à afficher ici",

    createContent: "Créer le contenu",

    maxDisplayNumber: "Nombre d'écrans max (Licences)",

    compositionModules: "Modules de l'organisation",
    compositionModulesSeparator: "(separateur: \";\")",
    compositionModuleRates: "Taux",
    compositionModuleQuestionForm: "Questionnaire",

    invalidValueFloat: "La valeur entrée doit être un nombre.",

    askForContactInformation: "Demander des informations de contact",
    goToNextQuestionAuto: "Naviguer automatiquement à la prochaine question",
    questionFormTitle: "Titre du questionnaire",

    questionTitle: "Question",
    questionType: "Type de question",
    questionTypeSingleSelection: "Selection unique",
    questionTypeMultiSelection: "Selection multiple",
    questionTypeNumeric: "Nombre",
    questionTypeDate: "Date",
    answer: "Réponse",
    answerValue: "Valeur de la réponse",
    removeAnswer: "Supprimer réponse",
    addAnswer: "Ajouter une réponse",
    removeQuestion: "Supprimer la question",
    addQuestion: "Ajouter une question",

    questionDefaultValue: "Valeur par défaut",
    minValue: "Valeur mini",
    maxValue: "Valeur max",
    moveUp: "Déplacer vers le haut",
    moveDown: "Déplacer vers le bas",

    compositionModuleLibrairiesParameters: "Paramètres des bibliothèques",
    banner: "Bannière",

    // Survey
    survey: "enquête",
    Forms: "Enquêtes",
    formsTitle: "Formulaires",
    CreateNewForm: "Nouvelle enquête",
    helmetFormsList: "SKA - Enquêtes",
    successfullSaveForm: "Ce formulaire a été sauvegardé avec succès.",
    formDuplicated: "Nouvelle enquête créé.",
    confirmDeleteForm: "Supprimer cette enquête ?",
    formDeleted: "Formulaire supprimé.",
    addForm: "Ajouter enquête",
    addQuizz: "Ajouter un Quizz",
    chooseForm: "Choisissez une enquête",
    quizzMode: "mode quizz",
    noteQuizzMode: "Remarque : lorsque le mode Quizz est activé, le sondage délivre un message de fin lié au score de l'utilisateur.",
    successScore: "Note de réussite",
    thanks: "Merci",
    inCaseOfSuccess: "En cas de succès",
    MessageAtEnd: "Message de fin",
    InCaseOfFail: "En cas d'echec",
    tagline: "Slogan",
    body: "Corps",
    addAnOption: "Ajouter option",

    questionForm: "Questions",
    responses: "Réponses",
    formStyle: "Style",

    averageTimeToAnswer: "Temps moyen pour compléter",
    totalAnswers: "Nombre de réponses",
    noResponsesYet: "Personne n'a encore répondu au questionnaire.",

    exportToCSV: "Exporter en CSV",

    treeHasModified: "Veuillez sauvegarder la composition pour modifier les paramètres.",

    backToMenu: "Retour au menu",
    addDataSource: "Ajouter la source de données",

    homepageDesigner: "Designer Page d'accueil",
    navigationMenuDesigner: "Designer la barre de navigation",

    appointementRestriction: "Horaires Rendez-vous",
    monday: "Lundi",
    tuesday: "Mardi",
    wednesday: "Mercredi",
    thursday: "Jeudi",
    friday: "Vendredi",
    saturday: "Samedi",
    sunday: "Dimanche",
    Morning: "Matin",
    Afternoon: "Après midi",

    // Contest
    Contests: "Jeux Concours",
    contestDeleted: "Jeu concours supprimé",
    contestDuplicated: "Jeu concours dupliqué",
    helmetContestsList: "SKA - Jeux concours",
    CreateNewContest: "Créer un Jeu concours",
    participations: "Participations",
    contestDetails: "Détails",
    contestStartDate: "Début du jeu concours",
    contestEndDate: "Fin du jeu concours (optionnel)",
    mustHaveStartDate: "Ce jeu concours doit avoir une date de début",
    successfullSaveContest: "Jeu concours sauvegardé avec succès.",
    confirmDeleteContest: "Supprimer ce jeu concours ?",
    addContest: "Ajouter jeu concours",
    chooseContest: "Choisir un jeu concours",
    firstName: "Prénom",
    lastName: "Nom",
    score: "Score",
    phone: "Téléphone",
    participationDate: "Date de participation",
    ratesFileFormat: "Le fichier n'est pas au bon format",

    // HomeDesigner
    pages: "pages",
    createNewPage: "ajouter une page",
    removeLastPage: "supprimer la dernière page",
    selectPageBackground: "arrière plan de la page",
    defaultLayout: "Mise en page par défaut",
    selectModulePreview: "previsualisation",
    selectModuleContent: "contenu affiché",
    selectModuleDataSource: "enquête affichée",
    fillLayout: "remplir la mise en page",
    imageInput: "sélectionner la prévisualisation",

    //Drugstores
    drugstoresTitle: "Pharmacies de garde",
    drugstoresDescription: "Une liste des pharmacies de garde ouvertes au Luxembourg",
    hero: "Hero",
    changeHero: "Remplacer",
    selectHero: "Selectionner",

    //Agenda
    agendaTitle: "Agenda",
    agendaDescription: "La liste de vos événements à venir avec description & QR Code pour l'inscription.",
    agendaEvents: "Evènements",
    agendaSubtitle: "Sous-titre ",
    selectCategory: "Changer le nom de la catégorie",
    addCategory: "Créer Nouveau",
    allCategory: "Catégories",
    newCategorie: "Nouvelle categorie",

    //Directory
    directoryTitle: "Répertoire",
    directoryDescription: "Les personnes de votre entreprise, répertoriées par thème avec leurs coordonnées",
    helmetDirectory: "SKA - Directory",
    memberCategories: "catégories de membres",
    people: "personnes",
    addPeople: "Ajouter personnes",
    emailAddress: "Adresse Email",
    linkedin: "Linkedin",

    //PDF Library
    helmetPDFLibrary: "SKA - PDF Library",
    pdflibraryTitle: "Bibliothèque de PDF",
    pdflibraryDescription: "Collection de documents .pdf (une seule page ou de plusieurs pages).",
    startPublicationDate: "Date de début de publication",
    endPublicationDate: "Date de fin de publication",
    fileAttributes: "Fichier attribué",
    availability: "Disponibilité",
    documentCategories: "Catégories de document",
    PDFCategories: "PDF catégories",

    //E-reider
    helmetEReider: "SKA - E-Reider",
    pdfEReiderTitle: "E-Reider",
    WPReiderTitle: "WP Reider",
    EReiderDescription: "Vos publications officielles organisées en catégories et disponibles en téléchargement.",

    // Pharmacy
    pharmacyTitle: "Pharmacie",
    pharmacyDescription: "La liste de pharmacie au Luxembourg, avec leurs adresses.",
    typePharmacy: "Ville",

    //Map
    mapTitle: "Carte",
    mapDescription: "Une carte avec des points d'intérêt tels que les arrêts de bus, les informations partagées sur la mobilité et la circulation.",
    mustHaveCenterCoordinates: "Vous devez spécifier les coordonnées du centre dela carte",
    mapCenterCoordinate: "Coordonnées du centre de la carte",
    mapshowBycicles: "Montrer les parkings de vélo",
    mapshowCameras: "Montrer les caméras de circulation",
    mapshowBus: "Montrer les horaires de bus",
    mapPOICoordinates: "Coordonnées du POI",
    newPOIGroup: "Nouveau Groupe de POI",
    newPOI: "Nouveau POI",
    title: "Titre",
    caption: "Légende",
    latitude: "Latitude",
    mapDisplaySettings: "Paramètres d'affichage de la carte",
    zoomLevel: "Niveau de zoom",
    level: "Niveau",
    carsLocationStations: "Stations de localisation des voitures",
    addGroupPOI: "Ajouter un groupe de POI",
    POIGroupSettings: "Parametres du groupe POI",
    groupName: "Nom du groupe",
    groupTitle: "Titre du groupe",
    groupIcon: "Icone du groupe",
    listeMap: "Liste",
    addPOI: "Ajouter un POI",
    modifyPOI: "Modifier POI",

    // Itinerary
    itinerary: "Itineraire",

    // News feeds
    newsFeed: "Fil d'actualité",

    // WP News
    WPNewsTitle: "WP Fil d'actualité",
    WPNewsDescription: "Votre fil d'actualité synchronisé depuis Wordpress et mis à jour quotidiennement.",

    // Jalios
    jaliosPhotoGallery: "Galerie photos de Jalios",
    jaliosAgenda: "Jalios Agenda",

    // Jalios Agenda
    helmetJaliosAgenda: "SKALINK - Jalios Agenda",
    mustHaveImageCategorie: "Cet élément doit avoir des images de catégories",

    //Mission4
    mission4Title: "Game · Mission4",
    mission4Description: "La mission est simple: Soyez le premier à aligner quatre jetons d'affilée pour gagner!",

    //News
    newsTitle: "News",

    //CustomNews
    custoNewsTitle: "CustomNews",
    custoNewsDescription: "Affichez vos headlines directement sur votre accueil",

    displayParameters: "Paramètres de l'écran",
    actions: "Actions",

    // Arendt Event categories
    ArendtInternalEvents: "Arendt internal events",
    ArendtClientsEvents: "Arendt clients events",
    ArendtEventsHosted: "External events hosted in Arendt House",
    ArendtSponsoring: "Sponsoring",
    ArendtTraining: "Training",
    ArendtRecruitment: "Recruitment"
};

export default lang;
